/* Copyright (c) 2022 Nordcloud Oy or its affiliates. All Rights Reserved. */

import * as React from "react";
import { ToastContainer } from "react-toastify";
import { Loader } from "@nordcloud/gnui";
import { useAuth0 } from "~/services/Auth/";
import { GlobalSwitch } from "./routing/GlobalSwitch";

export function App() {
  const { isLoading } = useAuth0();

  return isLoading ? (
    <Loader />
  ) : (
    <div css={{ flex: "1 0 auto" }}>
      <ToastContainer />
      <GlobalSwitch />
    </div>
  );
}
